module.exports = __webpack_public_path__ + "img/tinkerer.3cb0f5f2.png";